import React from 'react'
import RecipeItemStock from "./RecipeItemStock";
import RecipeItemQuantity from "./RecipeItemQuantity";
import RecipeItemUnit from "./RecipeItemUnit";
import RecipeItemPrice from "./RecipeItemPrice";
import RecipeItemCurrency from "./RecipeItemCurrency";
import RecipeItemParity from "./RecipeItemParity";
import RecipeItemTotal from "./RecipeItemTotal";
import RecipeItemDelete from "./RecipeItemDelete";

const RecipeItemListRows = ({id, rowCount}) => {

    return(
        <React.Fragment>
            <tr>
                <td>{rowCount + 1}</td>
                <td colSpan={4}> <RecipeItemStock rowId={id} /> </td>
                <td> <RecipeItemQuantity rowId={id} /> </td>
                <td> <RecipeItemUnit rowId={id} /> </td>
                <td> <RecipeItemPrice rowId={id}/> </td>
                <td> <RecipeItemCurrency rowId={id} /> </td>
                <td> <RecipeItemParity rowId={id} /> </td>
                <td> <RecipeItemTotal rowId={id} /> </td>
                <td> <RecipeItemDelete rowId={id} /> </td>
            </tr>
        </React.Fragment>
    )
}
export default RecipeItemListRows